module.exports = __webpack_public_path__ + "img/damir.0042244c.jpg";